export default __webpack_public_path__ + "static/MonumentGrotesk-Medium-717dd9af8fe6e17f118e1ad6e232ba3a.woff";